export const RECOMMENDATIONS = 'Recommendations';
export const ORDERED_BY_FIELD = 'OrderedByField';
